import { render } from "./DownloadSection.vue?vue&type=template&id=542c7f8c"
import script from "./DownloadSection.vue?vue&type=script&lang=js"
export * from "./DownloadSection.vue?vue&type=script&lang=js"
script.render = render

export default script